module.exports = "/static/media/fail.d2645994.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/fail.png
// module id = 1811
// module chunks = 0